export default "__VITE_ASSET__DgngmJLm__"